import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api";
import InputMask from "react-input-mask";
import Swal from "sweetalert2";
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer';
import Cropper from 'react-easy-crop';
import getCroppedImg from './../Utils/cropImage';
import { Container, Card, Form, Button, Modal, Spinner } from 'react-bootstrap';
import './AssociarLoja.css';

function LoadingOverlay({ show, message }) {
    if (!show) return null;
    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(255,255,255,0.9)', zIndex: 99999,
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'
        }}>
            <Spinner animation="border" style={{ color: '#8b0000', width: '3.5rem', height: '3.5rem' }} />
            <span className="mt-3 fw-bold text-danger">{message || "Aguarde... Enviando dados"}</span>
        </div>
    );
}

function ValidarUsuario() {
    const navigate = useNavigate();
    const chapa = localStorage.getItem("chapa");
    const [dados, setDados] = useState(null);
    const [foto, setFoto] = useState(null);
    const [imagem, setImagem] = useState(null);
    const [imagemBase64, setImagemBase64] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [croppedImagePreview, setCroppedImagePreview] = useState(null);
    const [whatsapp, setWhatsapp] = useState("");
    const [fixo, setFixo] = useState("");
    const [contato, setContato] = useState("");
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(true);
    const [enviando, setEnviando] = useState(false);
    const [showModalFoto, setShowModalFoto] = useState(false);

    const limparNumero = (valor) => (valor || "").replace(/\D/g, "");

    useEffect(() => {
        if (!chapa) {
            navigate("/arbor/usuario/criar");
            return;
        }
        const carregarDados = async () => {
            try {
                const dadosResp = await api.get(`/usuario/dados/${chapa}`);
                if (dadosResp.data.length > 0) {
                    const d = dadosResp.data[0];
                    setDados(d);
                    setWhatsapp(d.telefone2 || "");
                    setFixo(d.telefone1 || "");
                    setContato(d.telefone3 || "");
                    setEmail(d.email || "");
                }
                const fotoResp = await api.get(`/usuario/foto/${chapa}`);
                if (fotoResp.data?.foto) {
                    setFoto("data:image/jpeg;base64," + fotoResp.data.foto);
                }
            } catch (err) {
                Swal.fire("Erro", "Falha ao carregar dados", "error");
            } finally {
                setLoading(false);
            }
        };
        carregarDados();
    }, [chapa, navigate]);

    const handleFotoChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => {
            setImagem(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const onCropComplete = async (croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
        if (imagem) {
            try {
                const croppedUrl = await getCroppedImg(imagem, croppedAreaPixels);
                setCroppedImagePreview(croppedUrl);
            } catch (err) {
                console.error("Erro ao gerar preview:", err);
            }
        }
    };

    const gravarFoto = async () => {
        try {
            const croppedUrl = await getCroppedImg(imagem, croppedAreaPixels);
            const response = await fetch(croppedUrl);
            const blob = await response.blob();

            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = async () => {
                const base64Image = reader.result;
                setImagemBase64(base64Image);
                setFoto(base64Image);
                setShowModalFoto(false);
            };
        } catch (err) {
            console.error(err);
            Swal.fire("Erro", "Erro ao recortar imagem", "error");
        }
    };

    const salvar = async () => {
        if (!whatsapp.trim()) {
            Swal.fire("Atenção", "Informe o número do WhatsApp", "warning");
            return;
        }

        if (!email.trim()) {
            Swal.fire("Atenção", "Informe o e-mail", "warning");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            Swal.fire("Atenção", "E-mail inválido", "warning");
            return;
        }

        setEnviando(true);
        try {
            const respContato = await api.post(`/usuario/validacao/${chapa}`, {
                telefone1: limparNumero(fixo),
                telefone2: limparNumero(whatsapp),
                telefone3: limparNumero(contato),
                email: email,
            });
            if (respContato.status !== 201) {
                Swal.fire("Erro", "Erro ao salvar os dados de contato", "error");
                return;
            }
        } catch (err) {
            Swal.fire("Erro", "Falha na requisição dos dados de contato", "error");
            return;
        }

        if (imagemBase64) {
            try {
                const respFoto = await api.post(`/usuario/foto/${chapa}`, {
                    tipo: "",
                    imagem: imagemBase64,
                    loja: dados?.loja || "",
                });
                if (respFoto.status !== 201) {
                    Swal.fire("Erro", "Erro ao salvar a foto", "error");
                    return;
                }
            } catch (err) {
                Swal.fire("Erro", "Falha na requisição de envio da foto", "error");
                return;
            }
        }

        try {
            const respIntegracao = await api.post(`/restaurante/${chapa}/integracao`);
            if (respIntegracao.status !== 201) {
                Swal.fire("Erro", "Erro na integração com o restaurante", "error");
                return;
            }

            Swal.fire("Sucesso", "Usuário validado com sucesso!", "success").then(() => {
                localStorage.removeItem("chapa");
                navigate("/arbor/login");
            });
        } catch (err) {
            Swal.fire("Erro", "Falha na requisição de integração", "error");
        } finally {
            setEnviando(false);
        }
    };

    if (loading) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center vh-100 bg-light">
                <Spinner animation="border" style={{ color: '#8b0000', width: '3rem', height: '3rem' }} />
                <strong className="mt-3 text-dark">Carregando dados...</strong>
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
            <Menu modulo="NOVO" />

            <Container fluid className="px-3 mt-4 pt-4 mb-5" style={{ flex: 1, maxWidth: '520px' }}>
                <Card className="shadow-sm border-0 bg-white rounded-3 p-4">
                    <div className="text-center mb-4">
                        <h4 className="fw-bold text-dark m-0">
                            <i className="fa-solid fa-user-check text-danger me-2"></i>Validação de Dados
                        </h4>
                        <span className="small text-muted">Confirme e atualize seus dados de cadastro</span>
                    </div>

                    <div className="text-center mb-4">
                        <img
                            src={foto || "https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg"}
                            alt="Foto do Usuário"
                            className="rounded-circle shadow-sm border"
                            style={{
                                width: 120,
                                height: 120,
                                objectFit: "cover",
                                border: '3px solid #8b0000'
                            }}
                        />
                        <div className="mt-2">
                            <Button
                                variant="outline-danger"
                                size="sm"
                                className="btn-arbor-outline fw-bold"
                                onClick={() => setShowModalFoto(true)}
                            >
                                <i className="fa-solid fa-camera me-1"></i>Tirar Nova Foto
                            </Button>
                        </div>
                    </div>

                    <Form className="d-flex flex-column gap-3">
                        <Form.Group>
                            <Form.Label className="small fw-bold text-dark">
                                <i className="fa-brands fa-whatsapp text-success me-1"></i>WhatsApp *
                            </Form.Label>
                            <InputMask
                                mask="(99) 99999-9999"
                                value={whatsapp}
                                onChange={(e) => setWhatsapp(e.target.value)}
                            >
                                {(inputProps) => <Form.Control {...inputProps} placeholder="(00) 00000-0000" />}
                            </InputMask>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label className="small fw-bold text-dark">
                                <i className="fa-solid fa-phone text-muted me-1"></i>Telefone Fixo
                            </Form.Label>
                            <InputMask
                                mask="(99) 9999-9999"
                                value={fixo}
                                onChange={(e) => setFixo(e.target.value)}
                            >
                                {(inputProps) => <Form.Control {...inputProps} placeholder="(00) 0000-0000" />}
                            </InputMask>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label className="small fw-bold text-dark">
                                <i className="fa-solid fa-mobile-screen me-1 text-muted"></i>Contato Recado
                            </Form.Label>
                            <InputMask
                                mask="(99) 99999-9999"
                                value={contato}
                                onChange={(e) => setContato(e.target.value)}
                            >
                                {(inputProps) => <Form.Control {...inputProps} placeholder="(00) 00000-0000" />}
                            </InputMask>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label className="small fw-bold text-dark">
                                <i className="fa-solid fa-envelope me-1 text-muted"></i>E-mail *
                            </Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="seuemail@exemplo.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </Form.Group>

                        <Button
                            variant="danger"
                            className="btn-arbor-primary w-100 fw-bold py-2 mt-2"
                            onClick={salvar}
                            disabled={enviando}
                        >
                            <i className="fa-solid fa-check-double me-2"></i>Confirmar e Finalizar
                        </Button>
                    </Form>
                </Card>
            </Container>

            {/* MODAL DE FOTO */}
            <Modal show={showModalFoto} onHide={() => { setShowModalFoto(false); setImagem(null); setCroppedImagePreview(null); }} centered>
                <Modal.Header closeButton className="modal-header-arbor">
                    <Modal.Title className="h6 fw-bold text-white m-0">
                        <i className="fa-solid fa-camera me-2"></i>Tirar Foto
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    {imagem ? (
                        <>
                            <div style={{ position: 'relative', width: '100%', height: 300 }} className="rounded overflow-hidden">
                                <Cropper
                                    image={imagem}
                                    crop={crop}
                                    zoom={zoom}
                                    aspect={1}
                                    onCropChange={setCrop}
                                    onZoomChange={setZoom}
                                    onCropComplete={onCropComplete}
                                />
                            </div>
                            {croppedImagePreview && (
                                <div className="text-center mt-3">
                                    <p className="small text-muted mb-1">Pré-visualização:</p>
                                    <img
                                        src={croppedImagePreview}
                                        alt="Pré-visualização"
                                        style={{ width: 100, height: 100, borderRadius: '50%', border: '2px solid #8b0000', objectFit: 'cover' }}
                                    />
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="text-center py-3">
                            <img className="img-fluid rounded border mb-3" style={{ maxHeight: '250px' }} alt="Foto atual" src={foto} />
                            <Form.Group>
                                <Form.Control type="file" accept="image/*" capture="user" onChange={handleFotoChange} />
                            </Form.Group>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="border-top-0 pt-0">
                    <Button variant="secondary" onClick={() => { setShowModalFoto(false); setImagem(null); setCroppedImagePreview(null); }}>
                        Cancelar
                    </Button>
                    {imagem && (
                        <Button variant="danger" className="btn-arbor-primary" onClick={gravarFoto}>
                            Confirmar Foto
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>

            <LoadingOverlay show={enviando} message="Aguarde... Enviando dados" />
            <Footer />
        </div>
    );
}

export default ValidarUsuario;